"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5910],{

/***/ 6260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ RegisterForm; },
/* harmony export */   "U": function() { return /* binding */ LoginForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7536);
/* harmony import */ var _utils_form_validation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6001);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3757);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5295);
/* harmony import */ var _text_input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5169);










const VerifyCode = (param)=>{
    let { onChange , onSubmit , email , onResend  } = param;
    var _formState_errors_code;
    const { register , handleSubmit , setError , formState  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)();
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("app");
    const [resendStatus, setResendStatus] = react__WEBPACK_IMPORTED_MODULE_4__.useState("ok");
    const handleResend = async ()=>{
        setResendStatus("busy");
        try {
            await onResend();
            setResendStatus("disabled");
            setTimeout(()=>{
                setResendStatus("ok");
            }, 1000 * 30);
        } catch (e) {
            setResendStatus("ok");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: handleSubmit(async (param)=>{
                let { code  } = param;
                try {
                    await onSubmit(code);
                } catch (e) {
                    setError("code", {
                        type: "not_found",
                        message: t("wrongVerificationCode")
                    });
                }
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb-1 text-2xl font-bold",
                            children: t("verifyYourEmail")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-500",
                            children: t("stepSummary", {
                                current: 2,
                                total: 2
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                                t: t,
                                i18nKey: "verificationCodeSent",
                                values: {
                                    email
                                },
                                components: {
                                    b: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "whitespace-nowrap"
                                    }),
                                    a: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-link",
                                        href: "#",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            onChange();
                                        }
                                    })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_input__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                            autoFocus: true,
                            proportions: "lg",
                            error: !!formState.errors.code,
                            className: "w-full",
                            placeholder: t("verificationCodePlaceholder"),
                            ...register("code", {
                                validate: _utils_form_validation__WEBPACK_IMPORTED_MODULE_5__/* .requiredString */ .Jc
                            })
                        }),
                        ((_formState_errors_code = formState.errors.code) === null || _formState_errors_code === void 0 ? void 0 : _formState_errors_code.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-2 text-sm text-rose-500",
                            children: formState.errors.code.message
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-2 text-sm text-slate-400",
                            children: t("verificationCodeHelp")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "space-y-4 sm:flex sm:space-y-0 sm:space-x-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                            loading: formState.isSubmitting || formState.isSubmitSuccessful,
                            htmlType: "submit",
                            type: "primary",
                            className: "h-12 w-full px-6 sm:w-auto",
                            children: t("continue")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                            onClick: handleResend,
                            loading: resendStatus === "busy",
                            disabled: resendStatus === "disabled",
                            className: "h-12 w-full rounded-lg px-4 text-slate-500 transition-colors hover:bg-slate-500/10 active:bg-slate-500/20 sm:w-auto",
                            children: t("resendVerificationCode")
                        })
                    ]
                })
            ]
        })
    });
};
const RegisterForm = (param)=>{
    let { onClickLogin , onRegistered , defaultValues  } = param;
    var _formState_errors_name, _formState_errors_email;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("app");
    const { register , handleSubmit , getValues , setError , formState  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)({
        defaultValues
    });
    const requestRegistration = _utils_trpc__WEBPACK_IMPORTED_MODULE_6__/* .trpcNext.auth.requestRegistration.useMutation */ .G.auth.requestRegistration.useMutation();
    const authenticateRegistration = _utils_trpc__WEBPACK_IMPORTED_MODULE_6__/* .trpcNext.auth.authenticateRegistration.useMutation */ .G.auth.authenticateRegistration.useMutation();
    const [token, setToken] = react__WEBPACK_IMPORTED_MODULE_4__.useState();
    if (token) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerifyCode, {
            onSubmit: async (code)=>{
                const res = await authenticateRegistration.mutateAsync({
                    token,
                    code
                });
                if (!res.user) {
                    throw new Error("Failed to authenticate user");
                }
                onRegistered();
                posthog_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].identify */ .ZP.identify(res.user.id, {
                    email: res.user.email,
                    name: res.user.name
                });
                posthog_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].capture */ .ZP.capture("register");
            },
            onResend: async ()=>{
                const values = getValues();
                await requestRegistration.mutateAsync({
                    email: values.email,
                    name: values.name
                });
            },
            onChange: ()=>setToken(undefined),
            email: getValues("email")
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        onSubmit: handleSubmit(async (data)=>{
            const res = await requestRegistration.mutateAsync({
                email: data.email,
                name: data.name
            });
            if (!res.ok) {
                switch(res.code){
                    case "userAlreadyExists":
                        setError("email", {
                            message: t("userAlreadyExists")
                        });
                        break;
                }
            } else {
                setToken(res.token);
            }
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-1 text-2xl font-bold",
                children: t("createAnAccount")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-slate-500",
                children: t("stepSummary", {
                    current: 1,
                    total: 2
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "name",
                        className: "text-slate-500",
                        children: t("name")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_input__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                        className: "w-full",
                        proportions: "lg",
                        autoFocus: true,
                        error: !!formState.errors.name,
                        disabled: formState.isSubmitting,
                        placeholder: t("namePlaceholder"),
                        ...register("name", {
                            validate: _utils_form_validation__WEBPACK_IMPORTED_MODULE_5__/* .requiredString */ .Jc
                        })
                    }),
                    ((_formState_errors_name = formState.errors.name) === null || _formState_errors_name === void 0 ? void 0 : _formState_errors_name.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-sm text-rose-500",
                        children: formState.errors.name.message
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "email",
                        className: "text-slate-500",
                        children: t("email")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_input__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                        className: "w-full",
                        proportions: "lg",
                        error: !!formState.errors.email,
                        disabled: formState.isSubmitting,
                        placeholder: t("emailPlaceholder"),
                        ...register("email", {
                            validate: _utils_form_validation__WEBPACK_IMPORTED_MODULE_5__/* .validEmail */ .u$
                        })
                    }),
                    ((_formState_errors_email = formState.errors.email) === null || _formState_errors_email === void 0 ? void 0 : _formState_errors_email.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-1 text-sm text-rose-500",
                        children: formState.errors.email.message
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                loading: formState.isSubmitting,
                htmlType: "submit",
                type: "primary",
                className: "h-12 px-6",
                children: t("continue")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-4 border-t pt-4 text-slate-500 sm:text-base",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                    t: t,
                    i18nKey: "alreadyRegistered",
                    components: {
                        a: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/login",
                            className: "text-link",
                            onClick: onClickLogin
                        })
                    }
                })
            })
        ]
    });
};
const LoginForm = (param)=>{
    let { onAuthenticated , onClickRegister  } = param;
    var _formState_errors_email;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("app");
    const { register , handleSubmit , getValues , formState , setError  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)();
    const requestLogin = _utils_trpc__WEBPACK_IMPORTED_MODULE_6__/* .trpcNext.auth.requestLogin.useMutation */ .G.auth.requestLogin.useMutation();
    const authenticateLogin = _utils_trpc__WEBPACK_IMPORTED_MODULE_6__/* .trpcNext.auth.authenticateLogin.useMutation */ .G.auth.authenticateLogin.useMutation();
    const [token, setToken] = react__WEBPACK_IMPORTED_MODULE_4__.useState();
    if (token) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerifyCode, {
            onSubmit: async (code)=>{
                const res = await authenticateLogin.mutateAsync({
                    code,
                    token
                });
                if (!res.user) {
                    throw new Error("Failed to authenticate user");
                } else {
                    onAuthenticated();
                    posthog_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].identify */ .ZP.identify(res.user.id, {
                        email: res.user.email,
                        name: res.user.name
                    });
                    posthog_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].capture */ .ZP.capture("login");
                }
            },
            onResend: async ()=>{
                const values = getValues();
                const res = await requestLogin.mutateAsync({
                    email: values.email
                });
                setToken(res.token);
            },
            onChange: ()=>setToken(undefined),
            email: getValues("email")
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        onSubmit: handleSubmit(async (data)=>{
            const res = await requestLogin.mutateAsync({
                email: data.email
            });
            if (!res.token) {
                setError("email", {
                    type: "not_found",
                    message: t("userNotFound")
                });
            } else {
                setToken(res.token);
            }
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-1 text-2xl font-bold",
                children: t("login")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-slate-500",
                children: t("stepSummary", {
                    current: 1,
                    total: 2
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "email",
                        className: "text-slate-500",
                        children: t("email")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_input__WEBPACK_IMPORTED_MODULE_8__/* .TextInput */ .o, {
                        className: "w-full",
                        proportions: "lg",
                        autoFocus: true,
                        error: !!formState.errors.email,
                        disabled: formState.isSubmitting,
                        placeholder: t("emailPlaceholder"),
                        ...register("email", {
                            validate: _utils_form_validation__WEBPACK_IMPORTED_MODULE_5__/* .validEmail */ .u$
                        })
                    }),
                    ((_formState_errors_email = formState.errors.email) === null || _formState_errors_email === void 0 ? void 0 : _formState_errors_email.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2 text-sm text-rose-500",
                        children: formState.errors.email.message
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                        loading: formState.isSubmitting,
                        htmlType: "submit",
                        type: "primary",
                        className: "h-12 w-full px-6",
                        children: t("continue")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/register",
                        className: "btn-default h-12 w-full px-6",
                        onClick: (e)=>{
                            onClickRegister === null || onClickRegister === void 0 ? void 0 : onClickRegister(e, getValues("email"));
                        },
                        children: t("notRegistered")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



const TextInput = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function TextInput(param, ref) {
    let { className , error , proportions: size = "md" , ...forwardProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        ref: ref,
        type: "text",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("appearance-none rounded border border-gray-300 text-slate-700 shadow-sm placeholder:text-slate-400", className, {
            "px-2 py-1": size === "md",
            "px-3 py-2 text-xl": size === "lg",
            "input-error": error,
            "bg-slate-50 text-slate-500": forwardProps.disabled
        }),
        ...forwardProps
    });
});


/***/ }),

/***/ 8355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useRequiredContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useRequiredContext = (context, errorMessage)=>{
    const contextValue = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
    if (contextValue === null) {
        throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Missing context provider: ".concat(context.displayName));
    }
    return contextValue;
};


/***/ }),

/***/ 7348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NA": function() { return /* binding */ withSession; },
/* harmony export */   "aF": function() { return /* binding */ useUser; },
/* harmony export */   "dr": function() { return /* binding */ UserProvider; },
/* harmony export */   "wF": function() { return /* binding */ isUnclaimed; }
/* harmony export */ });
/* unused harmony exports UserContext, useAuthenticatedUser, IfAuthenticated, IfGuest */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3742);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3757);
/* harmony import */ var _use_required_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8355);
/* provided dependency */ var process = __webpack_require__(3454);







const UserContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createContext(null);
const useUser = ()=>{
    return (0,_use_required_context__WEBPACK_IMPORTED_MODULE_5__/* .useRequiredContext */ .a)(UserContext, "UserContext");
};
const useAuthenticatedUser = ()=>{
    const { user , ...rest } = useRequiredContext(UserContext, "UserContext");
    if (user.isGuest) {
        throw new Error("Forget to prefetch user identity");
    }
    return {
        user,
        ...rest
    };
};
const IfAuthenticated = (props)=>{
    const { user  } = useUser();
    if (user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const IfGuest = (props)=>{
    const { user  } = useUser();
    if (!user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const UserProvider = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.useContext */ .G.useContext();
    const { data: user  } = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.get.useQuery */ .G.whoami.get.useQuery();
    const [isUpdating, setIsUpdating] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const logout = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.destroy.useMutation */ .G.whoami.destroy.useMutation({
        onSuccess: async ()=>{
            setIsUpdating(true);
            await queryClient.whoami.invalidate();
            setIsUpdating(false);
        }
    });
    (0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(()=>{
        var _process_env_NEXT_PUBLIC_POSTHOG_API_KEY;
        posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].init */ .ZP.init((_process_env_NEXT_PUBLIC_POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY) !== null && _process_env_NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _process_env_NEXT_PUBLIC_POSTHOG_API_KEY : "fake token", {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
            opt_out_capturing_by_default: false,
            capture_pageview: false,
            capture_pageleave: false,
            autocapture: false,
            loaded: (posthog)=>{
                if (!process.env.NEXT_PUBLIC_POSTHOG_API_KEY) {
                    posthog.opt_out_capturing();
                }
                if (user && posthog.get_distinct_id() !== user.id) {
                    posthog.identify(user.id, !user.isGuest ? {
                        email: user.email,
                        name: user.name
                    } : {
                        name: user.id
                    });
                }
            }
        });
    });
    const shortName = user ? user.isGuest === false ? user.name : user.id.substring(0, 10) : t("guest");
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserContext.Provider, {
        value: {
            isUpdating,
            user: {
                ...user,
                shortName
            },
            refresh: ()=>{
                return queryClient.whoami.invalidate();
            },
            ownsObject: (param)=>{
                let { userId  } = param;
                if (userId && user.id === userId) {
                    return true;
                }
                return false;
            },
            logout: ()=>{
                logout.mutate();
            }
        },
        children: props.children
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const withSession = (component)=>{
    const ComposedComponent = (props)=>{
        const Component = component;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserProvider, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            })
        });
    };
    ComposedComponent.displayName = "withUser(".concat(component.displayName, ")");
    return ComposedComponent;
};
/**
 * @deprecated Stop using this function. All object
 */ const isUnclaimed = (obj)=>!obj.userId;


/***/ }),

/***/ 6001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jc": function() { return /* binding */ requiredString; },
/* harmony export */   "QZ": function() { return /* binding */ useFormValidation; },
/* harmony export */   "u$": function() { return /* binding */ validEmail; }
/* harmony export */ });
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);

/**
 * @deprecated Use form validation hook instead
 */ const requiredString = (value)=>!!value.trim();
/**
 * @deprecated Use form validation hook instead
 */ const validEmail = (value)=>/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
const useFormValidation = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)("app");
    return {
        requiredString: (name)=>(value)=>{
                if (!value.trim()) {
                    return t("requiredString", {
                        name
                    });
                }
            },
        validEmail: (value)=>{
            const isValidEmail = validEmail(value);
            if (!isValidEmail) {
                return t("validEmail");
            }
        }
    };
};


/***/ })

}]);